import { ApiRequestInterceptor } from "../Services/apiRequest";
import { RESTAURANTS } from "./Endpoints";

export const fetchRestaurants = async (limit) => {
  const url = limit
    ? `${RESTAURANTS.getRestaurants}?limit=${encodeURIComponent(limit)}`
    : RESTAURANTS.getRestaurants;

  const res = await ApiRequestInterceptor(url, "GET");
  const code = res.code ?? res.status ?? 0;
  const data = res.data ?? res; // por si tu interceptor envuelve el payload

  if (code === 200) {
    // Tu Lambda responde { items, count, nextToken? }. Nos quedamos solo con items.
    return data.items ?? [];
  }

  throw new Error("Error al obtener restaurantes");
};
